import { autoLcWorkerNotice } from '@/locales/ko/views/worker_notice';
const lc = autoLcWorkerNotice();
export const tableHeader = [
    {
        title: lc('list.table.id'),
        align: 'center',
        value: 'id',
        width: 100,
    },
    {
        title: lc('list.table.title'),
        align: 'center',
        value: 'title',
    },
    {
        title: lc('list.table.author'),
        align: 'center',
        value: 'userName',
        width: 160,
    },
    {
        title: lc('list.table.created_time'),
        align: 'center',
        value: 'created_time',
        width: 160,
    },
    {
        title: lc('list.table.edit'),
        align: 'center',
        value: 'edit',
        width: 190,
    },
];
export const searchTypeList = [
    {
        text: '제목',
        value: 'title',
    },
    {
        text: '제목1',
        value: 'title1',
    },
];
